import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query"; 
import { productService } from "../../services/product"; 
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

import { Toolbar } from "primereact/toolbar";
import DispatchDetails from "./DispatchDetails";
import formatDate from "../../components/ui/dateFormat";

export default function DispatchProducts() {
  const [days, setDays] = useState(1); 
  const [visible, setVisible] = useState(false); 
  const [dataRow, setRowData] = useState(null);
  const { data: products, isLoading } = useQuery({
    queryKey: ["dispatchProducts", days],
    queryFn: () =>
      productService.getDispatchProducts(days).then((res) => res.data),  
  });

   const formatNumber = (value) => {
    return new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
  };
  const mtBodyTemplate = (rowData) => {
    return formatNumber(rowData.sevkMt);
  };
  const kgBodyTemplate = (rowData) => {
    return formatNumber(rowData.sevkKg);
  }; const partiBodyTemplate = (rowData) => {
    return (<div>{rowData.belgeNo} / {rowData.parti}</div>);
  };
  const dateBodyTemplate = (rowData) => {
    return formatDate(rowData.sevkTar);
  };
  const cols = [
    { field: "sevkTar", header: "Tarih", body: dateBodyTemplate },
    { field: "urun", header: "Ürün" },
    { field: "kodu", header: "İşlem" },
    { field: "belgeNo", header: "Parti No",body:partiBodyTemplate }, 
    { field: "sevkKg", header: "Kg" ,body:kgBodyTemplate},
    { field: "sevkMt", header: "Mt",body:mtBodyTemplate },
  ];
  const viewRow = (rowData) => {
    setVisible(true);
    setRowData(rowData);
  };

  const actionBodyTemplate = (rowData) => {
    return <Button type="button" icon="pi pi-eye"  loading={isLoading}  text size="large"   onClick={() => viewRow(rowData)} rounded></Button>;
  };
  const startContent = (
    <div className="text-2xl font-bold">Sevke Hazır Ürünler</div>
  );

  const endContent = (
    <React.Fragment>
      <div className="flex gap-2 ">
        <Button loading={isLoading}
          size="small"
          label="1"
          className={`  ${days == 1  ? "bg-primary":"bg-primary-reverse"}`}
          onClick={() => setDays(1)}
        />
        <Button loading={isLoading}
          size="small"
          label="7"
          className={`  ${days == 7  ? "bg-primary":"bg-primary-reverse"}`}
          onClick={() => setDays(7)}
        />
        <Button loading={isLoading}
          size="small"
          label="30"
          className={` ${days == 30 ? "bg-primary":"bg-primary-reverse"}`}
          onClick={() => setDays(30)}
        /> 
        <Button loading={isLoading}
          size="small"
          label="60"
          className={` ${days == 60 ? "bg-primary":"bg-primary-reverse"}`}
          onClick={() => setDays(60)}
        />
      </div>
    </React.Fragment>
  );

 
  const footer = (
    <div className="flex justify-content-between ">
      <span>Ürün Sayısı : {products ? products.length : 0}</span>
      <span>Gün Sayısı : {days}</span>
    </div>
  );

  return (
    <div  >
        <DispatchDetails
        setVisible={setVisible}
        visible={visible}
        dataRow={dataRow} 
      />
    
           <Toolbar className="shadow-3 border-round-md  my-2"  start={startContent} end={endContent} />
     
 
        <DataTable loading={isLoading} 
           size="medium"     className="shadow-3 border-round-md table-content surface-ground"    scrollable scrollHeight="flex"
          emptyMessage="Liste Boş"
          footer={footer}
          value={products || []} 
        >
          {cols.map((col, i) => (
            <Column
              key={i}
              field={col.field}
              header={col.header}
              body={col.body}
            />
          ))}
          <Column
            headerStyle={{ width: "5rem", textAlign: "center" }}
            bodyStyle={{ textAlign: "center", overflow: "visible" }}
            body={actionBodyTemplate}
          />
        </DataTable>
      
    </div>
  );
}
